


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Hint } from './HintTool.models';

const MAX_HINT_TEXT_LENGTH = 161;

@Component({})
export default class HintTool extends Vue {
  @Prop() private hint!: Hint;

  @Emit() private linkClicked() {
    return;
  }

  public truncatedHintText() {
    const completeText = `${this.hint.headline} ${this.hint.text}`;
    if (completeText.length < MAX_HINT_TEXT_LENGTH) {
      return completeText;
    }
    const targetLengthForTextWithoutHeadline = MAX_HINT_TEXT_LENGTH - this.hint.headline.length - 1;
    const truncatedText = this.hint.text.substring(0, targetLengthForTextWithoutHeadline);
    return `${truncatedText}…`;
  }
}
